import {ValidatorInterface} from './ValidatorInterface';
import { AbstractValidator, ValidatorObject } from './AbstractValidator';

interface ArrayContainsValidatorObject extends ValidatorObject {
	items?: unknown[];
	condition?: ( item ) => boolean;
	invert?: boolean;
}

/**
 * Validator that checks if the passed array passes the check.
 */
export class ArrayContains extends AbstractValidator implements ValidatorInterface {
	private readonly items;
	private readonly condition: ( item ) => boolean;
	private readonly invert: boolean;

	/**
	 * Constructor.
	 *
	 * @param {ArrayContainsValidatorObject} options
	 */
	constructor( options: ArrayContainsValidatorObject ) {
		super( options );

		this.items = options.items;
		this.condition = options.condition;
		this.invert = options.invert;
	}

	/**
	 * @inheritDoc
	 */
	getMessage(): string {
		return super.getCustomMessage() ?? `Not all items match the expected value`;
	}

	/**
	 * @inheritDoc
	 */
	isValid(): boolean {
		const checkedItems = this.items.every( this.condition );

		return this.invert === false ? checkedItems : checkedItems === false;
	}
}
